module.exports = __webpack_public_path__ + "img/feedback-neutral.aec7e06d.png";